import KpiComponent from '@/components/Base/KpiComponent';

import { Grid, Stack } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';

import ColumnChartThree from '@/components/Base/ColumnChartThree';
import BarChart from '@/components/Base/BarChart';
import React from 'react';

export const FinancialDefault = () => {

  const onApplyFilter = (selectedYear: number) => {
    console.log('onApplyFilter selectedYear: ', selectedYear)
  }

  return (
    <>
      <Stack flexDirection={'row'} flexWrap={'wrap'} gap={'8px'}>
        <KpiComponent title={'Valor total Inadimplente'} value={'1.234.234,41'} />
        <KpiComponent title={'Quantidades de contas inadimplência'} value={'856'} />
        <KpiComponent title={'Percentual de inadimplência'} value={'5%'} />
      </Stack>
      <PeriodFilter years={[]} onApplyFilter={onApplyFilter} />

      <Grid mt={'30px'} container spacing={2}>
        <Grid item xs={6}>
          <ColumnChartThree />
        </Grid>
        <Grid item xs={6}>
          <BarChart />
        </Grid>
      </Grid>
    </>
  );
};
